import { render, staticRenderFns } from "./UcTariffCodeBadge.yaml?vue&type=template&id=3bf367d6&component"
import script from "./UcTariffCodeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcTariffCodeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports